import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Ireland",
  "use": "icon-Ireland-usage",
  "viewBox": "0 0 1533 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1533 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Ireland\"><path d=\"M0 0h511.008936v1024H0z\" fill=\"#009A64\" p-id=\"26156\" /><path d=\"M511.008936 0H1021.993918v1024H511.008936z\" fill=\"#FFFFFF\" p-id=\"26157\" /><path d=\"M1021.993918 0H1533.005848v1024H1021.993918z\" fill=\"#F48041\" p-id=\"26158\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol